import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NavLink as Link } from 'react-router-dom';
import { NavDropdown } from './menu-components';

export const EntitiesMenu = props => (
  // tslint:disable-next-line:jsx-self-close
  <NavDropdown icon="th-list" name="Entities" id="entity-menu">
    <MenuItem icon="asterisk" to="/entity/banking-user">
      Banking User
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/banking-user-profile">
      Banking User Profile
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/ibft-banks">
      Ibft Banks
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/ip-capture">
      Ip Capture
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/otp-sms">
      Otp Sms
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/billing-category">
      Billing Category
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/institutes">
      Institutes
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/beneficiaries">
      Beneficiaries
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/scheduled-payments">
      Scheduled Payments
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/scheduled-payment-attempts">
      Scheduled Payment Attempts
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/password-history">
      Password History
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/service-category">
      Service Category
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/service-companies">
      Service Companies
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/notification-template">
      Notification Template
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/security-question">
      Security Question
    </MenuItem>
    <MenuItem icon="asterisk" to="/entity/security-answer">
      Security Answer
    </MenuItem>
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
  </NavDropdown>
);
